export function removeBy<T>(items: T[], predicate: (item: T) => boolean): void {
    const index = items.findIndex(predicate);
    if (index >= 0) items.splice(index, 1);
}
